import { render, staticRenderFns } from "./DocumentPortalUpload.vue?vue&type=template&id=bd5fe0e6&scoped=true&"
import script from "./DocumentPortalUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentPortalUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPortalUpload.vue?vue&type=style&index=0&id=bd5fe0e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5fe0e6",
  null
  
)

export default component.exports